import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
export var api__getFinancePostData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(postId) {
    var _res$data;
    var params, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          params = {
            id: postId,
            thumb_size: 300,
            device_type: "web",
            include: "details,price,gallery,g4Data"
          };
          _context.n = 1;
          return fetcher().get("/post/view-online", {
            params: params
          });
        case 1:
          res = _context.v;
          if (res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.data) {
            res.data.data.post_id = postId;
          }
          return _context.a(2, res);
      }
    }, _callee);
  }));
  return function api__getFinancePostData(_x) {
    return _ref.apply(this, arguments);
  };
}();